<template>
    <CRow>
        <CCol col="12" lg="6">
            <CCard>
                <CCardHeader>
                    <strong>{{ adminObject.name }}</strong>
                </CCardHeader>
                <CCardBody>
                    <CDataTable
                        small
                        fixed
                        :header="false"
                        :items="visibleData"
                        :fields="fields"
                    />
                </CCardBody>
                <CCardFooter>
                    <CButton color="primary" @click="goBack">Назад</CButton>
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    export default {
    
        name: 'Profile',
    
        beforeRouteEnter(to, from, next) {
            next(vm => {
                vm.adminObject = JSON.parse(localStorage.getItem('profile'));
            })
        },

        data () {
            return {
                adminObject: {}
            }
        },
  
        computed: {
            fields() {
                return [
                    { key: 'key', label: '', _style: 'width:150px' },
                    { key: 'value', label: '', _style: 'width:150px' }
                ];
            },
            visibleData() {
                const adminDetails = Object.entries(this.adminObject);
                return adminDetails.map(([key, value]) => { return { key: fieldTitle(key), value } })
            }
        },
  
        methods: {
            goBack() {
                this.$router.go(-1);
            }
        }
    }
    function fieldTitle(field) {
        switch(field) {
        case 'id': return 'ID';
        case 'name': return 'Имя';
        case 'email': return 'Email';
        case 'enabled': return 'Активен';
        default: return field; 
        }
    }
</script>
